import React from 'react';
import PropTypes from 'prop-types';

import styles from './ContentBar.module.scss';

const ContentBar = props => {
  const { className } = props;
  return (
    <div
      className={`${styles.BarContainer} ${className}`}
      style={{ background: styles.PlaceholderDefaultColor }}
    />
  );
};

ContentBar.propTypes = {
  className: PropTypes.node
};

ContentBar.defaultProps = {
  className: ''
};

export default ContentBar;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/ContentBar/ContentBar.js